import { PaginationRequest } from './api';

export const RATING_SCORE_MAXIMUM = 7;

export enum DoujinSource {
	NHentai = 'nhentai',
	NekoHentai = 'neko-hentai',
	MikuDoujin = 'miku-doujin',
	Cat300 = 'cat300',
	HAni = 'h-ani',
	DoujinTH = 'doujin-th',
	DoujinTS = 'doujints',
	OKDoujinX = 'ok-doujinx',
	NHentaiWebsite = 'nhentai.website',
	NHentaiXXX = 'nhentai.xxx',
	NHentaiTO = 'nhentai.to',
	EcchiDoujin = 'ecchi-doujin',
	HentaiThai = 'hentaithai',
	ImHentai = 'imhentai',
	NetoruHentai = 'netoruhentai',
	Koharu = 'koharu'
}

export interface Doujin {
	doujinUUID?: string;
	imageURL: string;
	title: string;
	artists: string[];
	characters: string[];
	tags: string[];
	source: string;
	code: string;
	link: string;
	documentUUID?: string;
	isFavorite?: boolean;
	yourRating?: number;
}

export interface DoujinPaginationRequest extends PaginationRequest {
	search?: string;
	artists?: string;
	characters?: string;
	tags?: string;
	source?: string;
	code?: string;
	isFavorite?: boolean;
}

export interface DoujinDetail {
	title: string;
	artists: string[];
	characters: string[];
	tags: string[];
	source: string;
	code: string;
	link: string;
	coverImageURL: string;
	imageURLs: string[];
}

export interface DoujinOption {
	artists: string[];
	characters: string[];
	tags: string[];
}
